import 'slick-carousel/slick/slick';

$('.testimonials-slider').slick({
    arrows: true,
    dots: true,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    adaptiveHeight: true,
});